/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setActiveSelection } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import ImageSelector from 'pages/dashboard/embeds/management/customize/imageselector/imageselector';



/* ========== ~~~~~~~~~~ EMBED IMAGE SELECTOR : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, appStatus }) => ({
    currentPage: appStatus.currentPage,
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
    activeSelection: embedsState.embedManagementState.contentStatus.activeSelection,
    currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
});
const mapDispatchToProps = dispatch => ({
    setActiveSelection: selection => dispatch(setActiveSelection(selection)),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageSelector);
